import React from 'react';
import PropTypes from 'prop-types';

import Qualifications from 'components/Qualifications';

const CustomerQualifications = ({ id }) => {
  return <Qualifications id={id} type="User" />;
};

CustomerQualifications.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default CustomerQualifications;
